import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue";
import { appState } from '@/composable/appState';
import { ChatWidgetSettingsDataOptions, LocaleOptions } from '@/helper/const';
import { updateChatWidgetSetting } from '@/helper/helper';
import { UIFormItem, UISelect } from '@gohighlevel/ghl-ui';
export default /*#__PURE__*/ _defineComponent({
    __name: 'Language',
    setup(__props) {
        return (_ctx, _cache) => {
            return (_openBlock(), _createBlock(_unref(UIFormItem), {
                label: _ctx.$t('sidebar.selectLanguage'),
                "show-feedback": false,
                class: "my-2"
            }, {
                default: _withCtx(() => {
                    var _a;
                    return [
                        _createVNode(_unref(UISelect), {
                            id: "select-id",
                            value: (_a = _unref(appState).chatWidgetSettingsData) === null || _a === void 0 ? void 0 : _a.locale,
                            options: _unref(LocaleOptions),
                            clearable: false,
                            type: "default",
                            resetMenuOnOptionsChange: true,
                            placeholder: "Select one",
                            "onUpdate:value": _cache[0] || (_cache[0] =
                                val => _unref(updateChatWidgetSetting)(_unref(ChatWidgetSettingsDataOptions).LOCALE, val))
                        }, null, 8 /* PROPS */, ["value", "options"])
                    ];
                }),
                _: 1 /* STABLE */
            }, 8 /* PROPS */, ["label"]));
        };
    }
});
